// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__PuKJe","inner":"styles_inner__gKSKv","progress":"styles_progress__fPwZH","text":"styles_text__SOsNA"};